var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _c("div", { staticClass: "pretty p-icon p-jelly p-smooth p-curve" }, [
      _c("input", {
        staticClass: "checkbox",
        attrs: { id: _vm.uniqueId, disabled: _vm.readOnly, type: "checkbox" },
        domProps: { checked: _vm.localValue },
        on: { change: _vm.handleToggleBoolean },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "state p-success" }, [
        _c("i", { staticClass: "icon fa fa-check" }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "hidden-text clickable text-capitalize",
            attrs: { for: _vm.uniqueId },
          },
          [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }